import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'glcategory'
})
export class GlcategoryPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value == "1") {
      return "Assets";
    }
    if (value == "2") {
      return "Liability";
    }
    if (value == "3") {
      return "Capital";
    }
    if (value == "4") {
      return "Income";
    }
    if (value == "5") {
      return "Expenses";
    } 
  }

}
